import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { customerAuthInterceptor } from './services/auth.interceptor';
import { RuntimeConfigService } from './services/runtime-config.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    // Storefront talks to the API Maker backend (public /catalog + customer-auth APIs).
    // The interceptor attaches the customer's tokens to backend calls.
    provideHttpClient(withFetch(), withInterceptors([customerAuthInterceptor])),
    // Fetch the dynamic public config (Razorpay/Google/Facebook keys) before the app renders.
    provideAppInitializer(() => inject(RuntimeConfigService).load()),
    provideRouter(
      routes,
      // Scroll to top on every new navigation (footer links, nav, etc.) and
      // restore the previous position on back/forward — matches TSS.
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
    ),
  ]
};
